import { queryClient } from "@app/QueryClientWithHeaders";
import { GraphQLVersionRepository } from "@app/repositories/GraphQLRepositories/VersionRepository";
import { versionKeys } from "@app/store/queryKeys";
import { useMutation } from "@tanstack/react-query";

const versionRepository = new GraphQLVersionRepository();

export const useCheckDocument = (versionId: string) => {
    const { mutate: checkDocument, ...mutation } = useMutation({
        mutationFn: () => versionRepository.aiCheck(versionId),
        mutationKey: [...versionKeys.aiCheck(versionId)],
        onSettled: () => {
            queryClient.invalidateQueries({
                queryKey: [versionKeys.versionByDocumentURL],
            });
        },
    });
    return { checkDocument, ...mutation };
};
